import MysticalWave from "./MysticalWave";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import { industriesData } from "../data/industries.jsx";

function RedesignedIndustries() {
    const sectionRef = useScrollAnimation();

    return (
        <section ref={sectionRef} className="redesign-industries" style={{ position: 'relative', overflow: 'hidden', backgroundImage: 'url(/assets/img/EIE-Verticals.jpg)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
            <div style={{ position: 'absolute', inset: 0, background: 'rgba(0, 0, 0, 0.8)', zIndex: 1 }}></div>
            <MysticalWave />
            <div className="redesign-industries-container" style={{ position: 'relative', zIndex: 10 }}>
                <div className="redesign-section-header scroll-animate-fade">
                    <div className="redesign-section-label">VECTORS WE'RE TARGETING</div>
                    <h2 className="redesign-section-title"><span style={{color: '#F50000'}}>E</span>motional Intelligence Across Industries</h2>
                    <p className="redesign-section-description">
                       Originally born for the Media and Fashion industries, EIE is now expanding into Education, Insurance, and Healthcare. 
 Transforming how people connect with content in the moments that matter most -  <strong>the moment of intent</strong>.
                    </p>
                </div>
                <div className="redesign-industries-grid">
                    {industriesData.map((industry) => (
                        <div key={industry.id} className="redesign-industry-card scroll-animate">
                            <div className="redesign-industry-icon">{industry.icon}</div>
                            <h3 className="redesign-industry-name">{industry.name}</h3>
                            <p className="redesign-industry-description">{industry.description}</p>
                            <div className="redesign-industry-outcomes">
                                {industry.outcomes.map((outcome, i) => (
                                    <span key={i} className="redesign-outcome-badge">{outcome}</span>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default RedesignedIndustries;
